import { render, staticRenderFns } from "./Detection.vue?vue&type=template&id=7cb711e0&scoped=true&"
import script from "./Detection.vue?vue&type=script&lang=js&"
export * from "./Detection.vue?vue&type=script&lang=js&"
import style0 from "./Detection.vue?vue&type=style&index=0&id=7cb711e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb711e0",
  null
  
)

export default component.exports